import React from 'react';
import styles from './Footer.module.css';
import logoFooter from '../../assets/logo_footer.svg';
import whatsapp from '../../assets/whatsapp.svg';
import x from '../../assets/X.svg';
import linkein from '../../assets/linkein.svg';
import facebook from '../../assets/facebook.svg';
import instagram from '../../assets/instagram.svg';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.leftSection}>
        <p className={styles.followText}>Síguenos aquí</p>
        <div className={styles.socialIcons}>
          <a 
            href="https://wa.me/573234710933"
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <img src={whatsapp} alt="WhatsApp" className={styles.icon} />
          </a>
          <a 
            href="https://x.com/efigas_oficial?t=drsyT02YcFXrBsXqgKjm3Q&s=09" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="X (Twitter)"
          >
            <img src={x} alt="X" className={styles.icon} />
          </a>
          <a 
            href="https://www.linkedin.com/company/efigas/" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <img src={linkein} alt="LinkedIn" className={styles.icon} />
          </a>
          <a 
            href="https://www.facebook.com/share/1B7uFW4NB6/" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <img src={facebook} alt="Facebook" className={styles.icon} />
          </a>
          <a 
            href="https://www.instagram.com/efigasoficial?igsh=MXhxaHdlYXVkazh6OA==" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img src={instagram} alt="Instagram" className={styles.icon} />
          </a>
        </div>
      </div>
      <img src={logoFooter} alt="Logo Footer" className={styles.logo} />
    </footer>
  );
}

export default Footer;